'use es6';

import { useState } from 'react';
import { useDispatch } from 'react-redux';
import EditorActionsAndEventsContext from 'ContentEditorUI/context/EditorActionsAndEventsContext';
import EditorConfigSingleton from '../EditorConfigSingleton';
import setupBeforeUnloadCallback from 'ContentEditorUI/utils/setupBeforeUnloadCallback';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InitializeScalableEditorActionsAndEventsContext({
  children
}) {
  // This should only be called once on the first render, and that's it
  // That way, we don't trigger re-renders by changing the provider value
  const dispatch = useDispatch();
  const [value, __setValue] = useState(() => {
    const actions = EditorConfigSingleton.getIn(['redux', 'actions']);
    const saveActions = {
      save: opts => dispatch(actions.save(opts)),
      autoSave: opts => dispatch(actions.autoSave(opts)),
      autoSaveDebounced: opts => dispatch(actions.autoSaveDebounced(opts))
    };
    setupBeforeUnloadCallback(actions.autoSave);
    return {
      saveActions,
      bus: window.hubspot.ContentEditorUI.eventBus
    };
  });
  return /*#__PURE__*/_jsx(EditorActionsAndEventsContext.Provider, {
    value: value,
    children: children
  });
}